import React from "react";
import { CustomPrevArrow, CustomNextArrow } from "../arrow";

export const getSliderSettings = () => ({
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 2,
  slidesToScroll: 1,
  variableWidth: true,
  centerMode: true,
  responsive: [
    {
      breakpoint: 700,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
      },
    },
  ],
  prevArrow: <CustomPrevArrow />,
  nextArrow: <CustomNextArrow />,
});

export const shouldBeFullHeight = (receivedOptions) => {
  const planTipes = receivedOptions.map((option) => option.planosTipos);
  return !planTipes.some((plan) => plan.length > 1);
};
